import request from '../utils/request';
import { buildApiPayload } from '../utils/api';
import baseApi from './baseApi';

export function getEntreeChutes(params, signal) {
  return request({
    url: '/entreeChutesTimerCycleHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getEntreeChutesTotal(params, signal) {
  return request({
    url: '/entreeChutesTimerCycleHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExport(params) {
  return request({
    url: '/entreeChutesTimerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deleteEntreeChute(uuid) {
  return request({
    url: `/entreeChutesTimerCycleHistory/${uuid}`,
    method: 'delete',
  });
}

const entreeChutesApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    bulkDeleteEntreeChutesTCHs: builder.mutation({
      query: ({ uuids }) => ({
        url: '/entreeChutesTimerCycleHistory',
        method: 'DELETE',
        data: {
          uuids,
        },
      }),
    }),
  }),
});

export const {
  useBulkDeleteEntreeChutesTCHsMutation: useBulkDeleteEntreeChutesTCHs,
} = entreeChutesApi;

export default entreeChutesApi;
